/// <reference path="../../typings/browser.d.ts" />
/// <reference path="../../customtypings/eurovision-control/eurovision-control.d.ts" />

namespace Application.Directives {
    'use strict';
    /**
     * Factory callback type
     */
    declare type EurovisionControlDirectiveCb = () => EurovisionControlDirective;
    
    /**
     * Custom scope
     */
    export interface IEurovisionControlDirectiveScopeDef {
        // shared parameters
        type: string;
        name: string;

        // checkboxes and switches parameters
        value: string;
        size: string;
        color: string;
        label: string;
        labelOff: string;
        disabled: string;
        readOnly: string;
        invert: string;

        // radio buttons parameters
        options: string;
        optionSelected: string;
        layout: string;
        onEurovisionChange: string;
    }
    
    /**
     * Custom scope
     */
    export interface IEurovisionControlDirectiveScope extends ng.IScope {
        type: 'switch' | 'checkbox' | 'selectize' | 'filter';
        name: string;

        value: boolean;
        size: 'regular' | 'small' | 'large';
        color: 'blue' | 'red' | 'yellow' | 'green';
        label: string;
        labelOff: string;
        disabled: 'disabled' | 'true' | 'false' | boolean;
        readOnly: 'true' | 'false' | boolean;
        invert: 'true' | 'false' | boolean;
        labelToShow: string;
        getLabelToShow: () => void;
        toggleBoolStatus: () => void;

        options: EurovisionControl.IRadioOption[];
        optionSelected: EurovisionControl.IRadioOption;
        layout: 'inline';
        selectRadioOption: (option: EurovisionControl.IRadioOption) => void;
        onEurovisionChange: () => void;
    }
    
    export class EurovisionControlDirective implements ng.IDirective {
        public static $name: string = "eurovisionControl";
        public static $inject: string[] = [];
        
        public restrict: string = 'E';
        public transclude: boolean = false;
        public templateUrl: string = 'decorators/eurovision-control-directive.html';
        public link: (scope: IEurovisionControlDirectiveScope, element: JQuery, attrs: ng.IAttributes) => void;
        public scope: IEurovisionControlDirectiveScopeDef = {
            type: '@',
            name: '@',
            value: '=?', 
            size: '@',
            color: '@',
            label: '@',
            labelOff: '@',
            disabled: '@',
            readOnly: '@',
            invert: '@',
            options: '=',
            optionSelected: '=',
            layout: '@',
            onEurovisionChange: '&',
        };

        public static Factory(): EurovisionControlDirectiveCb {
            let directive: EurovisionControlDirectiveCb = () => {
                return new EurovisionControlDirective();
            };
            return directive;
        }

        constructor() {
            EurovisionControlDirective.prototype.link = (scope: IEurovisionControlDirectiveScope, element: JQuery, attrs: ng.IAttributes) => {

                scope.getLabelToShow = (): void => {
                    if (scope.label && scope.label !== '') {
                        if (scope.labelOff && scope.labelOff !== '' && !scope.value) {
                            scope.labelToShow = scope.labelOff;
                        } else {
                            scope.labelToShow = scope.label;
                        }
                    } else {
                        scope.labelToShow = undefined;
                    }
                };

                scope.toggleBoolStatus = (): void => {
                    if (scope.disabled !== 'disabled' && scope.disabled !== 'true' && scope.disabled !== true &&
                        scope.readOnly !== 'true' && scope.readOnly !== true)
                        scope.value = !scope.value;
                };

                scope.selectRadioOption = (option: EurovisionControl.IRadioOption): void  => {
                    if (option.disabled !== 'disabled' && option.disabled !== 'true' && option.disabled !== true)
                        for (let opt of scope.options) {
                            if (opt === option) {
                                opt.selected = true;
                                if (scope.optionSelected !== undefined) scope.optionSelected = opt;
                            } else {
                                opt.selected = false;
                            }
                        }
                    scope.onEurovisionChange();
                };

                if (scope.options !== undefined && scope.options.length > 0) {
                    for (let opt of scope.options)
                        if (opt.selected === true && opt.disabled !== 'disabled' && opt.disabled !== 'true' && opt.disabled !== true) {
                            scope.selectRadioOption(opt);
                            break;
                        }
                    if (scope.optionSelected === undefined) {
                        for (let opt of scope.options)
                            if (opt.disabled !== 'disabled' && opt.disabled !== 'true' && opt.disabled !== true) {
                                scope.selectRadioOption(opt);
                                break;
                            }
                    }
                }

                scope.getLabelToShow();

                scope.$watch('value', (newVal: boolean, oldVal: boolean) => {
                    if (newVal !== oldVal && (scope.type === 'checkbox' || scope.type === 'switch' || scope.type === 'filter')) {
                        scope.getLabelToShow();
                        if (oldVal !== undefined)
                            scope.onEurovisionChange();
                    }
                }, true);

                scope.$watch('disabled', (newVal: string | boolean, oldVal: string | boolean) => {
                    if (newVal !== oldVal)
                        scope.getLabelToShow();
                }, true);
            };
        }
    }
}